import React from "react";
import {useSelector} from "react-redux";
import {getInitials, capitalize} from "../../../_helpers/StringHelpers";

export function SettingsPanelToggler() {
    const currentCompany = useSelector(state => state.session.current_company);

    return (
        <div className="topbar-item">
            <div id="od_settings_panel_toggle"
                 className="btn btn-icon btn-icon-mobile w-auto btn-topbar d-flex align-items-center btn-lg px-3 waves-effect waves-light">
                <span className="symbol symbol-lg-35 symbol-25 symbol-light-danger">
                    <span className="symbol-label font-size-h5 font-weight-bold">{getInitials(currentCompany.company.company_name)}</span>
                </span>
                <span className="text-white font-weight-bold font-size-base d-none d-md-inline ml-3">
                    {currentCompany.company.company_name}
                </span>
            </div>
        </div>
    );
}
